import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly overlay = new BehaviorSubject<boolean>(false);

  getLoadingStatus(): boolean {
    return this.overlay.getValue();
  }

  showLoading(): void {
    this.overlay.next(true);
  }

  closeLoading(): void {
    this.overlay.next(false);
  }
}
